const sanitizeHtml = require("sanitize-html");

function text(value) {
    if (value == null || /^null$/i.test(String(value).trim())) return "";
    return String(value).trim();
}

function coordinate(value, limit) {
    const clean = text(value);
    const number = clean ? Number(clean) : NaN;
    return Number.isFinite(number) && Math.abs(number) <= limit ? number : null;
}

function normalizeBranches(rows) {
    const seen = new Set();
    return (Array.isArray(rows) ? rows : []).flatMap((row) => {
        if (!row || typeof row !== "object") return [];
        const id = text(row.id);
        const name = text(row.name);
        const latitude = coordinate(row.latitude, 90);
        const longitude = coordinate(row.longitude, 180);
        if (!id || !name || seen.has(id) || latitude === null || longitude === null) return [];
        seen.add(id);
        const address = text(row.address);
        const addressText = sanitizeHtml(address.replace(/<br\s*\/?\s*>|<\/p>/gi, " "), { allowedTags: [], allowedAttributes: {} })
            .replace(/&amp;/g, "&")
            .replace(/&nbsp;/g, " ");
        const email = text(row.email);
        return [
            {
                ...row,
                id,
                name,
                sequence: Number.isInteger(Number(row.sequence)) && Number(row.sequence) > 0 ? Number(row.sequence) : seen.size,
                address,
                addressText,
                latitude,
                longitude,
                city: text(row.city),
                province: text(row.province),
                tel_no: text(row.tel_no),
                email: /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email) ? email : "",
            },
        ];
    });
}

function normalizeClusters(rows) {
    const seen = new Set();
    return (Array.isArray(rows) ? rows : []).flatMap((row) => {
        if (!row || typeof row !== "object") return [];
        const id = text(row.id);
        const label = text(row.label);
        const parts = text(row.center).split(",");
        const latitude = coordinate(parts[0], 90);
        const longitude = coordinate(parts[1], 180);
        if (!id || !label || seen.has(id) || parts.length !== 2 || latitude === null || longitude === null) return [];
        seen.add(id);
        return [
            {
                ...row,
                id,
                label,
                active: row.active === true || row.active === 1 || row.active === "1",
                center: [latitude, longitude],
                zoom: Number.isFinite(Number(row.zoom_level)) && Number(row.zoom_level) >= 4 && Number(row.zoom_level) <= 18 ? Number(row.zoom_level) : id === "all" ? 6 : 9,
            },
        ];
    });
}

function filterBranches(branches, { keyword = "" } = {}) {
    const terms = text(keyword).toLowerCase().split(/\s+/).filter(Boolean);
    return branches.filter((branch) => {
        const searchable = `${branch.name} ${branch.city} ${branch.province} ${branch.addressText}`.toLowerCase();
        return terms.every((term) => searchable.includes(term));
    });
}

function directionsUrl(branch) {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${branch.latitude},${branch.longitude}`)}`;
}

module.exports = { normalizeClusters, normalizeBranches, filterBranches, directionsUrl };
